const DELIVERY_TYPES = {
  ADDRESS: 'address',
  PICK_UP_POINT: 'pickUpPoint',
};

export default DELIVERY_TYPES;
